import React, { PureComponent } from 'react'
import { string, bool, func } from 'prop-types'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import Button from '@active/react-ui/Button'
import I18nMessage from '../../../common/I18nMessage'

class GrantPermission extends PureComponent {
  static propTypes = {
    clientName: string,
    isGrantPermissionShow: bool,
    handleGrantPermissionClose: func.isRequired,
    handleGrantPermissionSubmit: func.isRequired,
  }

  static defaultProps = {
    clientName: '',
    isGrantPermissionShow: false,
  }

  handleSubmitBuilder = buttonId => () => {
    const { handleGrantPermissionSubmit } = this.props
    handleGrantPermissionSubmit({ buttonId })
  }

  render() {
    const { isGrantPermissionShow, clientName, handleGrantPermissionClose } = this.props
    return (
      <Modal
        autoFocusClose
        title={<I18nMessage id="passport.permission.title" />}
        shown={isGrantPermissionShow}
        onClose={handleGrantPermissionClose}
        className="passport-ui-app__modal"
        size="md"
      >
        <ModalBody>
          <div className="passport-content">
            <div className="passport-ui-app__subTitle">
              <I18nMessage id="passport.permission.notice" params={{ 0: clientName }} />
            </div>
            <div className="passport-ui-app__subTitle font-weight-600 text-font-18">
              <I18nMessage id="passport.permission.access" />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="passport-content-footer">
            <Button type="super" onClick={this.handleSubmitBuilder('allow')}>
              <I18nMessage id="passport.permission.btn.allow" />
            </Button>
            <Button type="secondary" onClick={this.handleSubmitBuilder('reject')}>
              <I18nMessage id="passport.permission.btn.notAllow" />
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

export default GrantPermission
